// LocalStoreAnalytics.tsx
import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Box, CircularProgress, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { http } from '../fx-core';

interface Analytics {
  totalReservations: number;
  pickedUp: number;
  delivered: number;
  noShow: number;
  stillReserved: number;
  conversionRate: number;
}

interface Props {
  open: boolean;
  bookingId: number;
  storeName?: string;
  onClose: () => void;
}

const LocalStoreAnalytics: React.FC<Props> = ({ open, bookingId, storeName, onClose }) => {
  const [analytics, setAnalytics] = useState<Analytics | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && bookingId) {
      setLoading(true);
      http.get({ url: `localstore/${bookingId}/analytics` })
        .then((res: any) => setAnalytics(res.data))
        .catch(() => setAnalytics(null))
        .finally(() => setLoading(false));
    }
  }, [open, bookingId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle disableTypography style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px' }}>
        <Typography variant="h6">{storeName || 'Stall'} — Analytics</Typography>
        <IconButton size="small" onClick={onClose}><CloseIcon fontSize="small" /></IconButton>
      </DialogTitle>
      <DialogContent dividers style={{ padding: 20 }}>
        {loading && <Box display="flex" justifyContent="center" py={4}><CircularProgress size={24} /></Box>}

        {!loading && analytics && (
          <>
            <Box textAlign="center" mb={2}>
              <Typography style={{ fontSize: 32, fontWeight: 700, color: '#2e7d32' }}>
                {analytics.conversionRate}%
              </Typography>
              <Typography style={{ fontSize: 12.5, color: '#888' }}>Conversion rate</Typography>
            </Box>
            <Grid container spacing={1.5}>
              {[
                { label: 'Total reservations', value: analytics.totalReservations, color: '#333' },
                { label: 'Picked up', value: analytics.pickedUp, color: '#2e7d32' },
                { label: 'Delivered', value: analytics.delivered, color: '#2e7d32' },
                { label: 'Still reserved', value: analytics.stillReserved, color: '#9a5f1f' },
                { label: "Didn't show", value: analytics.noShow, color: '#A9412F' }
              ].map((stat) => (
                <Grid item xs={6} key={stat.label}>
                  <Box border="1px solid #eee" borderRadius={8} p={1.5}>
                    <Typography style={{ fontSize: 20, fontWeight: 700, color: stat.color }}>{stat.value}</Typography>
                    <Typography style={{ fontSize: 11.5, color: '#999' }}>{stat.label}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </>
        )}

        {!loading && !analytics && (
          <Typography style={{ textAlign: 'center', color: '#999', padding: '24px 0' }}>
            No analytics available yet.
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default LocalStoreAnalytics;